/**
 * The judge's verdict, folded behind the thread's divider marker with the bucket riding
 * the pill, and the investigation in a column beneath.
 */

import type { ReactNode } from 'react';
import { GitCompareArrows } from 'lucide-react';
import { ThreadDisclosure } from '@/modules/simulator/ui/thread-disclosure';
import { JudgeVerdict } from './judge-verdict';
import { bucketTone } from './verdict-format';

interface VerdictDisclosureProps {
  /** The judge's comparison; null while it is still answering. */
  comparison: Record<string, unknown> | null;
  bucket: string | null;
  judging?: boolean;
  open: boolean;
  onToggle: () => void;
  children?: ReactNode;
  aiReply?: string;
  humanReply?: string;
}

export const VerdictDisclosure = ({
  comparison,
  bucket,
  judging = false,
  open,
  onToggle,
  children,
  aiReply,
  humanReply,
}: VerdictDisclosureProps) => (
  <ThreadDisclosure
    icon={GitCompareArrows}
    label={judging ? 'Judging…' : 'Verdict'}
    meta={bucket ? <span className={bucketTone(bucket)}>{bucket}</span> : undefined}
    active={judging}
    open={open}
    onToggle={onToggle}
  >
    <div className='flex flex-col gap-4 px-1 pt-3'>
      {comparison ? (
        <JudgeVerdict comparison={comparison} aiReply={aiReply} humanReply={humanReply} />
      ) : (
        <p className='text-xs leading-4 text-gray-800'>Comparing the two replies…</p>
      )}
      {children && <div className='flex flex-col gap-3 border-t border-gray-500 pt-3.5'>{children}</div>}
    </div>
  </ThreadDisclosure>
);
